import React from "react";
import { Link } from "react-router-dom";

export const CtaBanner: React.FC = () => {
  const perks = [
    { icon: "📊", text: "Dashboard completo" },
    { icon: "🚀", text: "Crie em minutos" },
    { icon: "🔒", text: "Pagamentos seguros" },
    { icon: "💰", text: "Programe seus ganhos" },
    { icon: "🤝", text: "Sistema de Afiliação" },
  ];

  return (
    <section className="bg-light px-3">
      <div
        className="container px-3 px-md-4 px-lg-0"
        style={{ maxWidth: 1240 }}
      >
        {/* Main Card */}
        <div
          className="position-relative overflow-hidden"
          style={{
            borderRadius: 24,
            padding: "2rem",
            background: "linear-gradient(135deg, #1a1a2e 0%, #2c2c54 100%)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          }}
        >
          {/* Decorative Glow */}
          <div
            style={{
              position: "absolute",
              top: -80,
              right: -80,
              width: 300,
              height: 300,
              background:
                "radial-gradient(circle, rgba(255,193,7,0.25), transparent)",
              borderRadius: "50%",
            }}
          />

          <div className="row align-items-center gy-4 position-relative">
            {/* LEFT */}
            <div className="col-12 col-lg-7">
              <span className="badge bg-warning text-white mb-3 fs-6 p-2">
                💡 Para vendedores
              </span>

              <h2
                className="fw-bold text-white mb-2"
                style={{
                  fontSize: "clamp(1.5rem, 4vw, 2.2rem)",
                  lineHeight: 1.2,
                }}
              >
                Crie sua rifa e{" "}
                <span className="text-warning">lucre de verdade.</span>
              </h2>

              <p
                className="mb-4"
                style={{
                  color: "rgba(255,255,255,0.7)",
                  maxWidth: 520,
                  fontSize: "0.95rem",
                }}
              >
                Qualquer pessoa pode criar uma campanha de rifa na nossa
                plataforma. Configure, divulgue e acompanhe tudo pelo celular.
              </p>
              <p
                className="mb-4"
                style={{
                  color: "rgba(255,255,255,0.7)",
                  maxWidth: 520,
                  fontSize: "0.95rem",
                }}
              >
                Afiliados: Além do mais, você pode convidar amigos e conhecidos
                para te auxiliar da venda dos tickets com comissão em percentual
                pré-ajustado que irão AUTOMATICAMENTE para a conta do mesmo,
                você consegue programar quanto quer pagar de comissão do seu
                lucro final.
              </p>

              {/* PERKS */}
              <div className="d-flex flex-wrap gap-2 mb-4">
                {perks.map((p) => (
                  <span
                    key={p.text}
                    style={{
                      background: "rgba(255,255,255,0.08)",
                      borderRadius: 50,
                      padding: "0.4rem 0.9rem",
                      fontSize: "0.9rem",
                      color: "rgba(255,255,255,0.85)",
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <span className="fs-6">{p.icon}</span> {p.text}
                  </span>
                ))}
              </div>

              {/* CTA */}
              <Link
                to="/vendedor"
                className="btn fw-bold d-inline-flex align-items-center gap-2"
                style={{
                  background: "linear-gradient(135deg, #ffc107, #ff9800)",
                  color: "#000",
                  borderRadius: 50,
                  padding: "0.8rem 1.8rem",
                }}
              >
                Quero Criar Minha Rifa →
              </Link>
            </div>

            {/* RIGHT */}
            <div className="col-12 col-lg-5">
              <div className="d-flex flex-column gap-4">
                {[
                  {
                    icon: "⚡",
                    title: "Tempo médio para criar",
                    value: "5 minutos",
                    sub: "do zero até publicado",
                  },
                  {
                    icon: "🤝",
                    title: "Acelere as suas vendas",
                    value: "Influenciadores",
                    sub: "alavancam suas vendas",
                  },
                  {
                    icon: "🤑",
                    title: "Comissionamento",
                    value: "Programe",
                    sub: "a comissão máxima e seu lucro estará seguro",
                  },
                  {
                    icon: "📈",
                    title: "Lucratividade",
                    value: "Grana Extra",
                    sub: "vendendo no automático",
                  },
                ].map((s) => (
                  <div
                    key={s.title}
                    className="d-flex align-items-center gap-3"
                    style={{
                      background: "rgba(255,255,255,0.08)",
                      borderRadius: 14,
                      padding: "0.9rem 1.1rem",
                      border: "1px solid rgba(255,255,255,0.08)",
                    }}
                  >
                    <span style={{ fontSize: "1.5rem" }}>{s.icon}</span>

                    <div>
                      <div
                        style={{
                          fontSize: "0.9rem",
                          color: "rgba(255,255,255,0.6)",
                        }}
                      >
                        {s.title}
                      </div>

                      <div
                        className="fw-bold text-white"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {s.value}
                        <span
                          style={{
                            fontSize: "0.75rem",
                            color: "rgba(255,255,255,0.6)",
                            marginLeft: 6,
                          }}
                        >
                          {s.sub}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
